import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const styles = theme => ({
  root: {
    display: 'inline',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing.unit,
    height: theme.spacing.unit * 6,
  },
  icon: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});

class ToolbarNovoReajuste extends React.Component {
  render () {
    const { classes, handleClickIncluir } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Button
            variant='contained'
            className={classes.button}
            onClick={handleClickIncluir}
            color='primary'
            size='small'
            title={'Adicionar um novo reajuste...'}>
            <AddIcon className={classes.icon} />
            {'Novo Reajuste...'}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ToolbarNovoReajuste);
